import { Record } from 'immutable';
import {
  LOADING_STARTED,
  SET_CUSTOMERS_LOADED,
  SET_APPOINTMENTS_LOADED,
  SET_REPORT_APPOINTMENTS_LOADED,
  PUBNUB_CHANGED,
  PUBNUB_HANDLED,
} from './constants';
import {
  IMPORT_CUSTOMERS,
} from './customers/constants';
import {
  IMPORT_APPOINTMENTS,
} from './appointments/constants';
import {
  IMPORT_REPORT_APPOINTMENTS,
} from './reports/constants';

const Initial = Record({
  loading_in_progress: false,
  customers_loaded: false,
  appointments_loaded: false,
  report_appointments_loaded: false,
  pubnub_change: false,
});

const initialState = new Initial();

function customersReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case LOADING_STARTED:
      return state.set('loading_in_progress', true);
    case SET_CUSTOMERS_LOADED:
      return state.set('customers_loaded', true);
    case SET_APPOINTMENTS_LOADED:
      return state.set('appointments_loaded', true);
    case SET_REPORT_APPOINTMENTS_LOADED:
      return state.set('report_appointments_loaded', true);
    case IMPORT_APPOINTMENTS:
    case IMPORT_REPORT_APPOINTMENTS:
      if (action.reset) {
        return state.set('loading_in_progress', false).set('report_appointments_loaded', false);
      }
    case IMPORT_CUSTOMERS:
      if (action.reset) {
        return state.set('loading_in_progress', false).set('customers_loaded', false);
      }
      return state.set('loading_in_progress', false);

    case PUBNUB_CHANGED:
      return state.set('pubnub_change', true);
    case PUBNUB_HANDLED:
      return state.set('pubnub_change', false);
    default:
      return state;
  }
}

export default customersReducer;
